import styledNormalize from 'styled-normalize';
import { createGlobalStyle } from 'styled-components';
import { COLORS } from './Consts';

export default createGlobalStyle`
  ${styledNormalize}

  * {
    font-family: 'Roboto', sans-serif;
    box-sizing: border-box;
  }

  button, input, select {
    font-family: 'Roboto', sans-serif !important;
  }

  html {
    height: -webkit-fill-available;
  }

  body {
    height: 100%;
    min-height: -webkit-fill-available;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    padding: 0;
    margin: 0;
    position: fixed;
    background-color: ${COLORS.lightGray2} !important;
  }

  .primary {
    background-color: ${COLORS.primary} !important;
  }

  // @media (prefers-color-scheme: dark) {
  //   body {
  //     background-color: ${COLORS.background} !important;
  //     color: ${COLORS.white} !important;
  //   }
  // }

.card-voting {
  width: 100% !important;
}
.card-voting .extra.content button {
  width: auto !important;
}
.card-voting .content {
  padding: 10px !important;
  border-top: none !important;
}
.test-tabs-main .ui.active.tab {
  padding: 5px;
}
.ui.card.card-voting {
  margin-top: 5px;
}
.polloiG-BOX label {
  font-size: 20px;
  font-weight: 600;
  line-height: 1em;
  margin: 0;
}
.create-poll-form .form-input {
  display: grid;
  margin-bottom: 10px;
}
.create-poll-form .form-input input {
  padding: 7px;
  border: 1px solid #b9b6b6;
  border-radius: 5px;
}
.form-select select {
  padding: 7px;
  border: 1px solid #b9b6b6;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 20px;
}
.submit-btn {
  padding: 7px 15px;
  background-color: #389084;
  border: none;
  border-radius: 5px;
  color: #fff;
}

.form-input label{
  font-weight:600;
}
.form-select label{
  font-weight:600;
}
`;

